import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { persistStore, persistReducer } from 'redux-persist'
import combineReducers from '../slices/index' // Assuming you have a slice named itemSlice

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['dashboard', 'departments', 'facilities'], // these reducers won't be persisted
}

// Combine all reducers
// const rootReducer = combineReducers(reducers)

// Wrap the rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, combineReducers)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false // Disable serializability check for persist
    })
})
export default store
export const persistor = persistStore(store)
